import { render, staticRenderFns } from "./BrandDashboard.vue?vue&type=template&id=eb94d73c"
import script from "./BrandDashboard.vue?vue&type=script&lang=js"
export * from "./BrandDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports